'use client';
import React from 'react';
import clsx from 'clsx';
import styles from './OptionChainMiddle.module.scss';

interface MiddleComponentProps {
  type: 'top' | 'middle' | 'bottom';
  text: number | string;
  variant: 'title' | 'value';
}

const typeModifierMap: Record<MiddleComponentProps['type'], string> = {
  top: styles.top,
  middle: styles.middle,
  bottom: styles.bottom,
};

const MiddleComponent = ({ text, type, variant }: MiddleComponentProps) => {
  return (
    <>
      <div className={clsx(styles.middleComponentContainerMobile, 'middle-block')}>
        <span className="strike-title">Strike</span>
        <div className="strike-price">{text}</div>
      </div>

      <div className={clsx(styles.middleComponentContainerDesktop, typeModifierMap[type])}>
        {variant == 'title' ? (
          <div>{text}</div>
        ) : (
          <div>
            <span>{text}</span>
          </div>
        )}
      </div>
    </>
  );
};
export default MiddleComponent;

